import { VApp } from 'vuetify/lib/components/VApp';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("transition", {
    attrs: {
      name: "fade"
    }
  }, [_vm.loaded ? _c(VApp, [_c("div", {
    staticClass: "app-header-v2",
    attrs: {
      elevation: "0"
    }
  }, [_c("router-link", {
    attrs: {
      to: {
        name: "home"
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var href = _ref.href,
          route = _ref.route,
          navigate = _ref.navigate;
        return [_c("img", {
          staticClass: "logo",
          attrs: {
            src: require("@/assets/images/c&m_long_logo_white.png"),
            alt: "Clos & Monopole"
          },
          on: {
            click: navigate
          }
        })];
      }
    }], null, false, 1163765143)
  }), _c("div", {
    staticClass: "header-utils"
  }, [_c("router-link", {
    attrs: {
      to: {
        name: "login"
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var href = _ref2.href,
          route = _ref2.route,
          navigate = _ref2.navigate;
        return [_c("img", {
          staticClass: "profile-img",
          attrs: {
            src: require("@/assets/images/icon_profil_white_white.svg"),
            alt: ""
          },
          on: {
            click: navigate
          }
        })];
      }
    }], null, false, 2453595081)
  })], 1)], 1), _c(VMain, {
    attrs: {
      id: "pre-home"
    }
  }, [_c(VContainer, {
    attrs: {
      "fill-height": !_vm.isPublicDashbord,
      fluid: ""
    }
  }, [_c("router-view")], 1)], 1), _c("footer-component", {
    attrs: {
      isTerms: true
    }
  })], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };